import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';

export function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <div className="container" style={{ textAlign: 'center', padding: '6rem 1rem' }}>
      <span style={{ fontSize: '4rem' }}>🔍</span>
      <h1 style={{ fontSize: '2.25rem', marginTop: '1rem', marginBottom: '0.75rem' }}>
        404 — {t('pageNotFound')}
      </h1>
      <p style={{ fontSize: '1.125rem', maxWidth: '500px', margin: '0 auto 2rem auto' }}>
        {t('pageNotFoundDesc')}
      </p>
      <Link to="/" className="btn btn-primary" style={{ padding: '0.75rem 1.75rem' }}>
        ← {t('backToHome')}
      </Link>
    </div>
  );
}
